import React from 'react';

import { useRouter } from 'next/navigation';
import dynamic from 'next/dynamic';

import { LoyaltyType } from '@api/index';
import { isClientSide } from '@utils/env';
import { getLoyalties } from '@hooks/cache';
import { typeToName } from '@utils/utils';
import { BasketLoyaltyInfoViewModel } from '@api/v3';
import useGetasPath from '@hooks/useGetasPath';

import { LoginModalContentWrapper } from './styled';
const KocAilemModal = dynamic(() => import('../modals/KocAilemModal'));

type LoginRedirectProps = {
  loyaltyType?: LoyaltyType;
  onCancel?: () => void;
  kocAilemControl?: boolean;
};
export const LoginRedirectModal = ({
  loyaltyType,
  onCancel,
}: LoginRedirectProps) => {
  const asPath = useGetasPath();
  const router = useRouter();
  return loyaltyType ? (
    <KocAilemModal
      onCancel={onCancel}
      onSubmit={() =>
        router.push(`/giris-yap?redirectUrl=${encodeURIComponent(asPath)}`)
      }
      content={
        <LoginModalContentWrapper>
          <span>
            {typeToName(loyaltyType)} fiyatlarını görmek için üye girişi
            yapmalısınız
          </span>
        </LoginModalContentWrapper>
      }
      isConfirmDisabled={false}
      isConfirmLoading={false}
      actionButtonText='Giriş Yap'
    />
  ) : null;
};

const LOYALTIES_WHITELIST = [
  LoyaltyType.ZUBIZU,
  LoyaltyType.TURK_TELEKOM,
  LoyaltyType.TURK_TELEKOM_PRIME,
  LoyaltyType.TURK_TELEKOM_PRIME_BUSINESS,
  LoyaltyType.SETUR_EMPLOYEE,
].map((x) => x?.toLocaleLowerCase());
export const shouldHideLoyalty = (
  loyaltyType = '',
  utm_source = '',
  isValidated = false
) => {
  if (!loyaltyType) return false;
  if (isValidated) return false;
  const loyalTypeLowerCase = loyaltyType?.toLowerCase();
  if (LOYALTIES_WHITELIST.indexOf(loyalTypeLowerCase) > -1) return false;
  return loyalTypeLowerCase === utm_source.toLowerCase() && isValidated;
};
const LOYALTIES_WHITELIST_AUTHENTICATION = [LoyaltyType.ZUBIZU].map((x) =>
  x?.toLocaleLowerCase()
);

export const requiredAuthentication = (loyaltyType = '') => {
  const loyalTypeLowerCase = loyaltyType?.toLowerCase().trim();
  return !(
    !loyaltyType ||
    LOYALTIES_WHITELIST_AUTHENTICATION.indexOf(loyalTypeLowerCase) > -1
  );
};

export const checkLoyaltyPreviouslyValidated = (loyalty = '') => {
  if (!loyalty) return true;
  if (isClientSide()) {
    const loyalties = getLoyalties() as BasketLoyaltyInfoViewModel;
    return Boolean(
      loyalties?.activatedLoyalties?.find(
        (i) => i?.toLocaleLowerCase() === loyalty?.toLocaleLowerCase()
      )
    );
  }
  return false;
};

export const getLoyaltyTypeFromUtmSource = (utm_source = '') => {
  if (!utm_source) return undefined as unknown as LoyaltyType;
  switch (utm_source.toLowerCase()) {
    case 'kocailem':
      return LoyaltyType.KOC_AILEM;
    default:
      return undefined as unknown as LoyaltyType;
  }
};
